export default {
  LOAD_LIST(state, data) {
    state.listaStatusOdontograma = data;
  },
  PREPARE_TO_EDIT(state, data) {
    state.statusOdontograma = data;
  },
  RESET(state) {
    state.statusOdontograma = {
      id: null,
      nome: "",
      descricao: "",
      corHex: "",
      ativo: true,
    };
  },
};
